__turbopack_context__.v({
  "blockContent": "user-info-form-module-sass-module__FTrMUG__blockContent",
  "blockFooter": "user-info-form-module-sass-module__FTrMUG__blockFooter",
  "buttonHoverEffect": "user-info-form-module-sass-module__FTrMUG__buttonHoverEffect",
  "email": "user-info-form-module-sass-module__FTrMUG__email",
  "field": "user-info-form-module-sass-module__FTrMUG__field",
  "iconVerified": "user-info-form-module-sass-module__FTrMUG__iconVerified",
  "message": "user-info-form-module-sass-module__FTrMUG__message",
  "phone": "user-info-form-module-sass-module__FTrMUG__phone",
  "verification": "user-info-form-module-sass-module__FTrMUG__verification",
  "verifyBtn": "user-info-form-module-sass-module__FTrMUG__verifyBtn",
  "warningIcon": "user-info-form-module-sass-module__FTrMUG__warningIcon",
});
